module.exports = __webpack_public_path__ + "resources/img/img_appen_data2_en.9495ff76f38d411fb8e85cbc62bf4905.png";